import { HiddenForm } from '../../organisms/pricetag/hidden-form';
import { useAppSelector } from '../../../redux/hooks';
import { RootState } from '../../../redux/store';
import { OrderFlow } from '../../../redux/orderFlow/orderFlowSlice';

const Payment = () => {
  const currentFlow = useAppSelector(state => state.orderFlow.flow);
  const contractResponse = useAppSelector(
    (state: RootState) => state.contracts.mainContract.response
  );
  const extraContractResponse = useAppSelector(
    (state: RootState) => state.contracts.extraContract.response
  );

  const activeContractResponse =
    currentFlow === OrderFlow.Flow2 ? extraContractResponse : contractResponse;

  const paymentData = activeContractResponse?.data
    ? {
        MerchantID: activeContractResponse.data.merchantId,
        AcquirerBIN: activeContractResponse.data.acquirerBIN,
        TerminalID: activeContractResponse.data.terminalId,
        URL_OK: activeContractResponse.data.urlOk,
        URL_NOK: activeContractResponse.data.urlNok,
        Firma: activeContractResponse.data.firma,
        Cifrado: activeContractResponse.data.cifrado,
        Num_operacion: activeContractResponse.data.mumOperacion,
        Importe: activeContractResponse.data.importe,
        TipoMoneda: activeContractResponse.data.tipoMoneda,
        Exponente: activeContractResponse.data.exponente,
        Pago_soportado: activeContractResponse.data.pagoSoportado,
        Descripcion: activeContractResponse.data.descripcion,
        Idioma: activeContractResponse.data.idioma
      }
    : {};

  const paymentUrl = activeContractResponse?.paymentUrl || '';

  return (
    <div>
      <HiddenForm payment={{ url: paymentUrl, data: paymentData }} />
    </div>
  );
};

export default Payment;
